var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.componentType)?_c(_vm.componentType,_vm._g(_vm._b({tag:"component",attrs:{"task-id":_vm.taskId}},'component',Object.assign({}, _vm.writablePropsData, _vm.$attrs),false),Object.assign({}, _vm.listeners, _vm.$listeners))):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }